export default function () {

    const CMHR_SPLASH_KEY = "cmhrAcknowledgeSplash";

    window.curtainSettings = {
        curtainModeQuery: window.matchMedia ? window.matchMedia('(min-width: 56.25em) and (min-height: 35em)') : null,
        isCurtain: () => window.curtainSettings.curtainModeQuery && window.curtainSettings.curtainModeQuery.matches
    };
        document.documentElement.classList.add("supports-curtain");
       

    const setPageState = function (isSplashVisible) {
        window.curtainSettings.header = document.querySelector('.js-head-wrapper');
        window.curtainSettings.scrollToSticky = function() {
            if (!(window.location && window.location.hash)) {
                setTimeout(() => {
                    const offset = !window.curtainSettings.isCurtain() && window.curtainSettings.header ? window.curtainSettings.header.getBoundingClientRect().height : 0;
                    const curtainHeight = window.curtainSettings.curtainEl ? window.curtainSettings.curtainEl.getBoundingClientRect().height : window.innerHeight;
                    window.scrollTo(0, curtainHeight - offset);
                    setTimeout(() => {
                      document.documentElement.classList.remove("raised-curtain-load");
                    });
                }, 1);
                return true;
            } else {
                document.documentElement.classList.remove("raised-curtain-load");
                return false;
            }
        }
        if (!isSplashVisible) {
            window.curtainSettings.scrollToSticky();
        } 
    }

    const getSplashAcknowledge = function () {
        return window.sessionStorage.getItem(CMHR_SPLASH_KEY) || window.localStorage.getItem(CMHR_SPLASH_KEY);
    };


    const splashDialog = function(splashDialogElement, timeout) {

        const getStorageForWriting = function () {
            return timeout == 'session' ? window.sessionStorage : window.localStorage;
        }

        const recordSplashAcknowledge = function () {
            getStorageForWriting().setItem(CMHR_SPLASH_KEY, 'y');
        };



        const initSplash = function () {
          
            addSplashListeners();
            setPageState(true);
   
        };


   
        const addSplashListeners = function () {
            setTimeout(() => {
                recordSplashAcknowledge();
            }, 1000);
        };

        if (splashDialogElement) {
            initSplash();
        }
    }

    const isNoSplash = function() {
        if (window.location && window.location.search && typeof(window.URLSearchParams) == 'function') {
            const searchParams = new URLSearchParams(window.location.search);
            return searchParams.has('skipCmhrIntro') && searchParams.get('skipCmhrIntro') == 'y';
        } else if (window.location && window.location.hash) {
            return true;
        } else {
            return false;
        }
    }

    const splashAck = isNoSplash() || getSplashAcknowledge();
    if (splashAck) {
         document.documentElement.classList.add("raised-curtain-load");
    }

    window.initCmhrSplashScreen = function () {
        const splashEl = document.getElementById("splash-screen");
        if (splashEl) {
             document.body.addEventListener(
               "focus",
               (e) => {
                 if (
                   window.scrollY < window.innerHeight &&
                   document.activeElement &&
                   document.activeElement.closest(".sticky-under-curtain")
                 ) {
                   window.scrollTo(window.scrollX, window.innerHeight);
                 } else if (document.activeElement.closest("#splash-screen")) {
                   window.scrollTo(window.scrollX, 0);
                 }
               },
               true
             );
        }
        window.curtainSettings.curtainEl = splashEl;
        try {
            if (!splashAck) {
                if (splashEl) {
                    splashDialog(splashEl, splashEl.dataset.timeout);
                } else {
                    setPageState(false);
                }

            } else {
                setPageState(false);
            }
        } catch (e) {
            setPageState(false)
        }
    }
    return window.curtainSettings;

}